import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CdssStore, ICdssStore } from '../../models/cdss-store/CdssStore';
import { LanguageStore, LanguageStoreModel } from '../../models/language-store/language-store';
import { AuthInfoStore, IAuthInfoStore } from '../auth-info-store/AuthInfoStore';
import { ILoadingStore, LoadingStore } from '../loading-store/LoadingStore';
import { IResponseStore, ResponseStore } from '../response-store/ResponseStore';
import { IUserStore, UserStore } from '../user-store/UserStore';
import { CutoffStore } from '../cutoff-store/CutoffStore';
import { ICutoff } from '../cutoff/Cutoff';
import { PredictionRecordStore } from '../prediction-record-store/PredictionRecordStore';
import { IPredictionRecord } from '../prediction-record/PredictionRecord';
import { IMessageStore, MessageStore } from '../message-store/MessageStore';
import { ITermsStore, TermsStore } from '../terms-store/TermsStore';
import { CommonCodeStore, ICommonCodeStoreSnapshot } from '../common-code-store/CommonCodeStore';
import { IMedicalDeviceInfoStore, MedicalDeviceInfoStore } from '../medical-device-info-store/MedicalDeviceInfoStore';

/**
 * A RootStore model.
 */
// prettier-ignore
export const RootStoreModel = types.model("RootStore").props({
    languageStore: types.optional(LanguageStoreModel, {} as LanguageStore),
    cdssStore: types.optional(CdssStore, {} as ICdssStore),
    userStore: types.optional(UserStore, {} as IUserStore),
    loadingStore: types.optional(LoadingStore, {} as ILoadingStore),
    responseStore: types.optional(ResponseStore, {} as IResponseStore),
    authInfoStore: types.optional(AuthInfoStore, {} as IAuthInfoStore),
    cutoffStore: types.optional(CutoffStore, {} as ICutoff),
    predictionRecordStore: types.optional(PredictionRecordStore, {} as IPredictionRecord),
    messageStore: types.optional(MessageStore, {} as IMessageStore),
    termsStore: types.optional(TermsStore, {} as ITermsStore),
    commonCodeStore: types.optional(CommonCodeStore, {} as ICommonCodeStoreSnapshot),
    medicalDeviceInfoStore: types.optional(MedicalDeviceInfoStore, {} as IMedicalDeviceInfoStore),
})
    .actions((self) => ({
        afterCreate() {
            self.commonCodeStore.getCdssCodes();
        },
    }));
/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> { }

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> { }
